import { motion } from "framer-motion";
import { ExternalLink, Lock } from "lucide-react";

// Real client showcase. Add new clients to this array as they launch.
const CLIENTS = [
  {
    name: "Hat Daddy",
    tagline: "Crowns for Royalty",
    category: "E-commerce · AI Virtual Try-On",
    blurb:
      "A premium online hat boutique where shoppers upload a photo and use AI to see themselves in any fedora before they buy — turning browsers into buyers.",
    logo: "/assets/client-hatdaddy.png",
    liveUrl: "", // add the live link when it launches
  },
];

export const ClientsHelped = () => {
  return (
    <section id="clients" data-testid="clients-section" className="relative py-24 sm:py-32 border-t border-line">
      <div className="container-x">
        <div className="max-w-2xl mb-14">
          <span className="mono-label text-accent">[ Clients we've helped ]</span>
          <h2 className="font-head font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 text-balance">
            Real brands. Real results.
          </h2>
          <p className="text-text-2 mt-4 leading-relaxed">
            A look at the businesses we're proud to build for.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {CLIENTS.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`client-card-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex flex-col border border-line bg-surface overflow-hidden accent-glow"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-surface-2 flex items-center justify-center p-6">
                <img
                  src={c.logo}
                  alt={`${c.name} logo`}
                  loading="lazy"
                  className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-ink/80 border border-line text-white mono-label px-3 py-1 !text-[0.6rem]">
                  {c.category}
                </div>
              </div>

              <div className="p-7 flex flex-col flex-1">
                <h3 className="font-head font-black text-2xl">{c.name}</h3>
                <span className="mono-label text-accent mt-1">{c.tagline}</span>
                <p className="text-text-2 text-sm leading-relaxed mt-4 flex-1">{c.blurb}</p>

                {c.liveUrl ? (
                  <a
                    href={c.liveUrl}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`client-live-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className="mt-6 inline-flex items-center justify-center gap-2 bg-accent text-ink font-head font-bold py-3 hover:bg-white transition-colors"
                  >
                    View live site <ExternalLink className="w-4 h-4" />
                  </a>
                ) : (
                  <button
                    disabled
                    data-testid={`client-comingsoon-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className="mt-6 inline-flex items-center justify-center gap-2 border border-line text-text-2 font-head font-semibold py-3 cursor-not-allowed"
                  >
                    <Lock className="w-4 h-4" /> Live Demo Coming Soon
                  </button>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
